import { loaderService } from "../../../common/custom-loader/loader-service";
import { GET_STAKEHOLDER_COMMENTS, INSERT_STAKEHOLDER_COMMENTS } from '../../../common/URLs';

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from "react-toastify";
import jwt from 'jwt-decode';
import { clearLocalStorage } from '../../../common/Utils';
import { appInsights } from "../../../AppInsights";
import apiClient from "../../../axios";

export const authorizeCode = (authCode, refreshToken, setInactivityThreshold, setLastActivityTime, setEmail) => {
    var details;
    const client_id = process.env.REACT_APP_CLIENT_ID;
    const client_secret = process.env.REACT_APP_CLIENT_SECRET;
    if (refreshToken) {
        details = {
            'client_id': client_id,
            'client_secret': client_secret,
            'grant_type': 'refresh_token',
            'scope': client_id + " offline_access",
            'refresh_token': refreshToken
        };
    }
    else {
        details = {
            'client_id': client_id,
            'client_secret': client_secret,
            'grant_type': 'authorization_code',
            'scope': client_id + " offline_access",
            'code': authCode
        };
    }

    var formBody = [];
    for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    var url = process.env.REACT_APP_ADB2C_URL + "/" + localStorage.getItem('policy') + "/oauth2/v2.0/token";
    loaderService.showLoader();
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Accept': 'application / json; charset=utf - 8'
        },
        body: formBody
    }).then(function (response) {
        loaderService.hideLoader();
        return response.json();
    }).then(function (data) {
        if (!data.error && data.id_token) {
            loaderService.hideLoader();
            localStorage.setItem('id_token', data.id_token);
            localStorage.setItem('refresh_token', data.refresh_token);
            localStorage.setItem('loginStatus', true);
            const decoded = jwt(getLocalStorageItem('id_token'));
            setInactivityThreshold((decoded.exp - decoded.iat) * 1000);
            if (authCode)
                setLastActivityTime(Date.now());
            setEmail(decoded.emails?.[0]);
           if(decoded.extension_URN) {
            localStorage.setItem('urn', decoded.extension_URN);
            appInsights.setAuthenticatedUserContext(decoded.extension_URN);
           } 
        }
        else if (data.error) {
            clearLocalStorage();
        }
    });

}

export function getAllComments(stakeHolderMasterID, setCommentsData) {
    loaderService.showLoader();
    apiClient
        .post(GET_STAKEHOLDER_COMMENTS,
            {
                "stakeHolderMasterID": stakeHolderMasterID
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }
        )
        .then((response) => {
            setCommentsData(response.data.stakeholderComments);
            loaderService.hideLoader();
        })
        .catch(function (error) {
            console.log("apiClientERROR", error);
            loaderService.hideLoader();
        });
}

export function insertComment(commentDataArray, stakeholderMasterID, setCommentsData) {
    loaderService.showLoader();
    apiClient
        .post(INSERT_STAKEHOLDER_COMMENTS,
            {
                "stakeholderComments": commentDataArray,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                }
            }
        )
        .then((response) => {
            if(response.data.isSuccess === true) {
                toast.success("Comment saved successfully")
            }
            else toast.error("Error in saving comment")
            getAllComments(stakeholderMasterID, setCommentsData)
            loaderService.hideLoader();
        })
        .catch(function (error) {
            console.log("apiClientERROR", error);
            loaderService.hideLoader();
        });
}